import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=1bb05dc0&scoped=true&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style0 from "./layout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./layout.vue?vue&type=style&index=1&id=1bb05dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb05dc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb05dc0')) {
      api.createRecord('1bb05dc0', component.options)
    } else {
      api.reload('1bb05dc0', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=1bb05dc0&scoped=true&", function () {
      api.rerender('1bb05dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/layout/layout.vue"
export default component.exports